export const FETCH_ENROLLED_USER_DETAILS = 'FETCH_ENROLLED_USER_DETAILS'
export const FETCH_ENROLLED_USER_DETAILS_SUCCESS =
  'FETCH_ENROLLED_USER_DETAILS_SUCCESS'
export const FETCH_ENROLLED_USER_DETAILS_FAILURE =
  'FETCH_ENROLLED_USER_DETAILS_FAILURE'
export const SEND_MESSAGE_TO_PEERS = 'SEND_MESSAGE_TO_PEERS'
export const SEND_MESSAGE_TO_PEERS_SUCCESS = 'SEND_MESSAGE_TO_PEERS_SUCCESS'
export const SEND_MESSAGE_LIMIT_REACHED = 'SEND_MESSAGE_LIMIT_REACHED'
